<template>
  <div />
</template>



<script>
  import events from '@/services/events';



  export default {
    name: 'FourOhFourPage',

    metaInfo() {
      return {
        title: '404'
      };
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        events.emit('full-page-message', {
          type: 'generic-error',
          button: 'goToDefaultPage'
        });
      }
    }
  };
</script>
